.EventTileIcon {
  display: block;
  padding: 0.25rem;
  border: 0;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
  width: fit-content;

  &:global(.active) {
    background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
    &:hover {
      background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
    }
  }

  &:global(.done) {
    background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
    color: rgb(21 128 61 / var(--tw-text-opacity, 1));
    cursor: not-allowed;
  }

  &:global(.inactive) {
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
    cursor: not-allowed;
  }

  & img {
    width: 1.5rem;
    height: 1.5rem;
    max-width: 100%;
  }
}
